var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 19.5C13 19.2239 13.2239 19 13.5 19H17.5C17.7761 19 18 19.2239 18 19.5C18 19.7761 17.7761 20 17.5 20H13.5C13.2239 20 13 19.7761 13 19.5Z",
    fill: "#00112B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 16.5C13 16.2239 13.2239 16 13.5 16H17.5C17.7761 16 18 16.2239 18 16.5C18 16.7761 17.7761 17 17.5 17H13.5C13.2239 17 13 16.7761 13 16.5Z",
    fill: "#00112B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 12C13.2239 12 13 12.2239 13 12.5V13.5C13 13.7761 13.2239 14 13.5 14H15.5C15.7761 14 16 13.7761 16 13.5V12.5C16 12.2239 15.7761 12 15.5 12H13.5Z",
    fill: "#00112B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2485 9C17.733 9 18.201 9.17584 18.5655 9.49485L21.317 11.9024C21.751 12.2822 22 12.8308 22 13.4075V21C22 22.1046 21.1046 23 20 23H12C10.8954 23 10 22.1046 10 21V11C10 9.89543 10.8954 9 12 9H17.2485ZM11 21C11 21.5523 11.4477 22 12 22H20C20.5523 22 21 21.5523 21 21V13.4075C21 13.1192 20.8755 12.8448 20.6585 12.655L17.907 10.2474C17.7247 10.0879 17.4908 10 17.2485 10H12C11.4477 10 11 10.4477 11 11V21Z",
    fill: "#00112B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.885f26cd4fcae2564ab255664b3a5384.svg";
export { ForwardRef as ReactComponent };